import React from 'react';
import * as StyledOutcome from 'apps/journey/pages/my-journey2/outcomes/styled-outcome';
import { pluralize, ellipse } from 'library/helpers/text';
import hasHoc from 'util/hoc/has-hoc';
import PropTypes from 'prop-types';
import OutcomeHeaderActionOptions from 'apps/journey/pages/my-journey2/outcomes/outcome-header-actions-options';
import { Header2 } from 'library/components/text-elements';

const CardHeader = ({
  id,
  name,
  numGoals,
  configuration,
  setFlipped,
  isVisible,
}) => {
  return (
    <StyledOutcome.HeaderRow>
      <Header2>
        {ellipse(name, 25)}
        &nbsp;
        <span>
          {numGoals} {pluralize('Goal', numGoals)}
        </span>
      </Header2>
      <OutcomeHeaderActionOptions
        configuration={configuration}
        setFlipped={setFlipped}
        isVisible={isVisible}
        front
        id={id}
        label="Flip to view goals"
        outcome={{ name: name }}
      />
    </StyledOutcome.HeaderRow>
  );
};

CardHeader.propTypes = {
  id: PropTypes.number,
  name: PropTypes.string,
  colors: PropTypes.object,
  numGoals: PropTypes.number,
  configuration: PropTypes.object,
  setActive: PropTypes.func,
  setFlipped: PropTypes.func,
  isVisible: PropTypes.bool,
};

CardHeader.hoc_list = ['withConfig'];

export default hasHoc(CardHeader);
